import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_contest_problem_card = _resolveComponent("base-contest-problem-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contestDay.problems, (problem) => {
      return (_openBlock(), _createBlock(_component_base_contest_problem_card, {
        key: problem.id,
        day: _ctx.contestDay.day,
        onClick: () => _ctx.onClick(problem.id),
        problem: problem
      }, null, 8, ["day", "onClick", "problem"]))
    }), 128))
  ]))
}